import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ccm-autopartage',
  templateUrl: './ccm-autopartage.component.html',
  styleUrls: ['./ccm-autopartage.component.scss']
})
export class CcmAutopartageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }


getSite(): string {
  const host = location.host;

  switch (host) {
    case 'mam.clem.mobi':
    case 'www.mam.clem.mobi':
      return 'mam';

    // case 'localhost:4200':
    // case `devghiles.clem.mobi` : 
    case 'remiautopartage.clem.mobi':
    case 'www.remiautopartage.clem.mobi':
      return 'remi';

    default:
      return 'default';
  }
}




}
